import React from "react";
import { useSelector } from "react-redux";
import SubmitButton from "../../components/SubmitButton";
import Table from "../../components/Table";
import useAuth from "../../hooks/useAuth";
import { Checkbox } from "@mui/material";
const FilesList = ({ handleAddEmail,handleAddMultipleEmails, selectedEmails }) => {
  const { isAdmin, isCompany,isManager } = useAuth();
  const { email } = useSelector((state) => state.Email);

  const labels = [<Checkbox
    checked={selectedEmails.length == email.length}
    onChange={async (e) => {
      if (e.target.checked) {
        handleAddMultipleEmails(email);
      } else {
        handleAddMultipleEmails([]);
      }
    }}
  />, "Email", "Name", (isAdmin || isCompany) && "Actions"].filter(
    (item) => item
  );
  
  
  const data = email
    ? email.map((item) => {
        return {
          data: item,
          fields: [
            <Checkbox
              checked={selectedEmails.filter(data => data.email == item.email).length > 0}
              disabled={true}
            />,
            item?.email,
            item?.name,
            (isAdmin || isCompany || isManager) && (
              <SubmitButton
                style={{ marginLeft: "15px" }}
                title={"Select"}
                onClick={() => handleAddEmail(item)}
                color={"success"}
                loaderColor={"white"}
                disabled={selectedEmails.filter(data => data.email == item.email).length > 0}
              />
            ),
          ].filter((it) => it),
        };
      })
    : [];
  return (
    <div className="col-md-12 col-lg-6">
        <Table labels={labels} data={data} heightControl={true} />
    </div>
  );
};

export default FilesList;
